
export async function downloadPdf(url: string): Promise<ArrayBuffer> {
  const resp = await fetch(url)
  if (resp.status != 200) {
    throw new Error(`unexpected status '${resp.status}' for url '${url}'`)
  }

  return await resp.arrayBuffer()
}